import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "invisible" }

import * as Tone from 'tone'
import { onMounted, onUnmounted, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'HzPlayer',
  props: {
    frequency: {},
    gain: {},
    Q: {},
    panning: { default: 0 },
    lrDelay: { default: 0 },
    lGain: { default: 1 },
    rGain: { default: 1 }
  },
  setup(__props: any) {

const props = __props

const noise = new Tone.Noise('pink')
const noiseShaper1 = new Tone.Filter(440, 'bandpass')
const noiseShaper2 = new Tone.Filter(440, 'bandpass')
const gainNode = new Tone.Gain()
const panningNode = new Tone.Panner()
const splitterNode = new Tone.Split(2)
const leftDelayNode = new Tone.Delay()
const rightDelayNode = new Tone.Delay()
const leftGainNode = new Tone.Gain()
const rightGainNode = new Tone.Gain()
const mergeNode = new Tone.Merge()

onMounted(() => {
  noise.chain(noiseShaper1, noiseShaper2, gainNode, panningNode, splitterNode)
  gainNode.gain.value = props.gain
  noiseShaper1.frequency.value = props.frequency
  noiseShaper1.Q.value = props.Q
  noiseShaper2.frequency.value = props.frequency
  noiseShaper2.Q.value = props.Q
  panningNode.pan.value = props.panning

  splitterNode.connect(leftDelayNode, 0)
  splitterNode.connect(rightDelayNode, 1)
  leftDelayNode.connect(leftGainNode)
  rightDelayNode.connect(rightGainNode)
  leftGainNode.connect(mergeNode, 0, 0)
  rightGainNode.connect(mergeNode, 0, 1)
  mergeNode.connect(Tone.Destination)

  leftDelayNode.delayTime.value = Math.max(props.lrDelay, 0)
  rightDelayNode.delayTime.value = Math.max(-props.lrDelay, 0)
  leftGainNode.gain.value = props.lGain
  rightGainNode.gain.value = props.rGain

  noise.start()
})

onUnmounted(() => {
  noise.dispose()
  noiseShaper1.dispose()
  noiseShaper2.dispose()
  gainNode.dispose()
  panningNode.dispose()
})

watch(() => props.frequency, (v) => {
  noiseShaper1.frequency.value = v
  noiseShaper2.frequency.value = v
})

watch(() => props.gain, (v) => {
  gainNode.gain.value = v
})

watch(() => props.Q, (v) => {
  noiseShaper1.Q.value = v
  noiseShaper2.Q.value = v
})

watch(() => props.panning, (v) => {
  panningNode.pan.value = v
})

watch(() => props.lrDelay, (v) => {
  leftDelayNode.delayTime.value = Math.max(v, 0)
  rightDelayNode.delayTime.value = Math.max(-v, 0)
})

watch(() => props.lGain, (v) => {
  leftGainNode.gain.value = v
})

watch(() => props.rGain, (v) => {
  rightGainNode.gain.value = v
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})